import React from "react";
import { useInView } from "react-intersection-observer";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";

import newMexicoStateAthletics from "../../../assets/new-mexico-state-athletics.png";
import aggieMemorialStadium from "../../../assets/aggie-memorial-stadium.png";
import panAmericanArena from "../../../assets/pan-american-arena.png";
import niagaraIceDogs from "../../../assets/niagara-iceDogs.png";
import desMoinesBuccaneers from "../../../assets/des-moines-buccaneers.png";
import iowaBulls from "../../../assets/iowa-bulls.png";
import houstonBulls from "../../../assets/houston-bulls.png";
import ogdenRaptors from "../../../assets/ogden-raptors.png";
import provincialJuniorHockeyLeague from "../../../assets/provincial-junior-hockey-league.png";

export default function Partners() {
  // DEV make this better
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const partners = [
    {
      id: "1",
      name: "New Mexico State Athletics",
      logo: newMexicoStateAthletics,
    },
    {
      id: "2",
      name: "Aggie Memorial Stadium",
      logo: aggieMemorialStadium,
    },
    {
      id: "3",
      name: "Pan American Arena",
      logo: panAmericanArena,
    },
    {
      id: "4",
      name: "Niagara IceDogs",
      logo: niagaraIceDogs,
    },
    {
      id: "5",
      name: "Des Moines Buccaneers",
      logo: desMoinesBuccaneers,
    },
    {
      id: "6",
      name: "Iowa Bulls",
      logo: iowaBulls,
    },
    {
      id: "7",
      name: "Houston Bulls",
      logo: houstonBulls,
    },
    {
      id: "8",
      name: "Ogden Raptors",
      logo: ogdenRaptors,
    },
    {
      id: "9",
      name: "Provincial Junior Hockey League",
      logo: provincialJuniorHockeyLeague,
    },
  ];

  return (
    <section className="partners">
      <div ref={ref}>
        <div
          className={`partners_inner_div info-container ${inView ? "text_appear_two" : ""}`}
        >
          <h1 className="display-4 fw-semi-bold pb-2 text-md-center">
            Meet Some of Our Partners.
          </h1>
          <p className="display-text">
            These teams put their trust in us to deliver a seamless ticketing
            experience that maximizes revenue and strengthens fan loyalty.
          </p>
          <Stack
            gap={3}
            className="mt-5 partners-container flex-lg-row justify-content-center align-items-center"
          >
            {partners?.map((partner) => (
              <Card
                body
                id={`partner-${partner.id}`}
                key={`partner-${partner.id}`}
                className="d-flex-column justify-content-between"
              >
                <Card.Img src={partner.logo} alt={partner.name} />
                <Card.Text className="text-nowrap fw-semi-bold">
                  {partner?.name}
                </Card.Text>
              </Card>
            ))}
          </Stack>
        </div>
      </div>
    </section>
  );
}
